"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mezzanego": {
    "7c32be63": [{
      "hkey": "d8b944dd",
      "slug": "mezzanego",
      "name": "Mezzanego",
      "primary": true,
      "skipSearch": false
    }],
    "case-zatta": [{
      "hkey": "d8b944dd",
      "slug": "mezzanego",
      "name": "Mezzanego",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3c28c07": [{
      "hkey": "d8b944dd",
      "slug": "mezzanego",
      "name": "Mezzanego",
      "primary": true,
      "skipSearch": false
    }],
    "corerallo": [{
      "hkey": "d8b944dd",
      "slug": "mezzanego",
      "name": "Mezzanego",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d73763d5": [{
      "hkey": "d8b944dd",
      "slug": "mezzanego",
      "name": "Mezzanego",
      "primary": true,
      "skipSearch": false
    }],
    "mezzanego-alto": [{
      "hkey": "d8b944dd",
      "slug": "mezzanego",
      "name": "Mezzanego",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fe31711f": [{
      "hkey": "d8b944dd",
      "slug": "mezzanego",
      "name": "Mezzanego",
      "primary": true,
      "skipSearch": false
    }],
    "passo-del-bocco": [{
      "hkey": "d8b944dd",
      "slug": "mezzanego",
      "name": "Mezzanego",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "598c24f9": [{
      "hkey": "8654c80b",
      "slug": "prati-di-mezzanego",
      "name": "Prati di Mezzanego",
      "primary": true,
      "skipSearch": false
    }],
    "vignolo": [{
      "hkey": "8654c80b",
      "slug": "prati-di-mezzanego",
      "name": "Prati di Mezzanego",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mezzanego"
    }]
  }
};
exports["default"] = _default;